import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4bYRoKeiWohoLJcupQpB/locations/XTbKyFvanmcfUt8bCbmn`}
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="240px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4bYRoKeiWohoLJcupQpB/locations/XTbKyFvanmcfUt8bCbmn`}
              target="_blank"
            >
              <CFView hover mt="5px">
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="230px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
